export const amortizationHeader = [
  {
    head: "Payment Date",
  },
  {
    head: "Principal",
  },
  {
    head: "Interest",
  },
  {
    head: "Monthly Total",
  },
  {
    head: "Principal Balance",
  },
];
